import React, { useEffect } from "react";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { useStyles } from "./OrderHistoryListViewStyles";
import { LoadingScreen, NoResultsMessage } from "../../shared";
import { OrderHistoryList } from "../OrderHistoryList";

export const OrderHistoryListView = () => {
  const styles = useStyles();
  const appInsights = useAppStore((state) => state.appInsights);
  const context = useAppStore((state) => state.context);
  const ordersHistory = useAppStore((state) => state.ordersHistory);

  const {
    loading: loadingOrderHistory,
    fetch: fetchOrdersHistory,
    values: orderHistory,
  } = ordersHistory;

  // Initializes the component
  useEffect(() => {
    fetchOrdersHistory();
  }, []);
  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "OrderHistoryListView",
    });
  }, [context, appInsights]);

  const orderCount = orderHistory?.length ?? 0;
  const statusMessage = loadingOrderHistory
    ? "Loading order history."
    : orderCount > 0
      ? `${orderCount} order${orderCount === 1 ? "" : "s"} in your order history.`
      : "No order history found.";

  return (
    <div className={styles.container} data-testid="OrderHistoryListView">
      <main className={styles.main}>
        {/* TalkBack and VoiceOver do not reliably announce an aria-live region whose
            entire subtree is swapped (as happens here between LoadingScreen,
            OrderHistoryList and NoResultsMessage). Instead, keep a single, persistent,
            visually-hidden status node mounted and only change its text -- that's the
            pattern both screen readers announce consistently. */}
        <span
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className={styles.visuallyHidden}
          data-testid="orderHistoryStatus"
        >
          {statusMessage}
        </span>
        <div className={styles.subMainContainer}>
          {loadingOrderHistory ? (
            <LoadingScreen />
          ) : orderHistory && orderHistory.length > 0 ? (
            <OrderHistoryList ordersHistory={orderHistory} />
          ) : (
            <NoResultsMessage
              primaryMessage="Looks like you haven't placed any orders with us yet."
              secondaryMessage="Once you start ordering, your history will show up here. Check out today's menu to place your first order!"
              isOrderHistoryVisible={true}
            />
          )}
        </div>
      </main>
    </div>
  );
};
